import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BreedersRoutes } from './breeders.routes';
import { BreedersComponent } from './breeders.component';
import { LayoutAdminModule } from '../../layout/admin/layout-admin.module';
import { MatIcon } from '@angular/material/icon';
import { SharedModule } from '../../shared/shared.module';
import { CommonComponentsModule } from '@homeleite/common-components';
import { RouterModule } from '@angular/router';


@NgModule({
    declarations: [
        BreedersComponent
    ],
    imports: [
        CommonModule,
        CommonComponentsModule,
        BreedersRoutes,
        LayoutAdminModule,
        MatIcon,
        SharedModule
    ],
    exports: [
        RouterModule
    ]
})
export class BreedersModule {}
